import { OPTIMEX_RPC_API_KEY, OPTIMEX_RPC_URL } from '@/utils'

import axios from 'axios'

export class OptimexRpcClient {
  async callRpc<T>(networkId: string, params: any): Promise<T> {
    const url = `${OPTIMEX_RPC_URL}/${networkId}/rpc/${OPTIMEX_RPC_API_KEY}`

    try {
      const response = await axios.post(url, params, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response.data
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(`API request failed: ${error.message}`)
      }
      throw error
    }
  }
}
